import { render, staticRenderFns } from "./EmailNotValidatedPage.vue?vue&type=template&id=f460dbc0&scoped=true&"
import script from "./EmailNotValidatedPage.vue?vue&type=script&lang=js&"
export * from "./EmailNotValidatedPage.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotValidatedPage.vue?vue&type=style&index=0&id=f460dbc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f460dbc0",
  null
  
)

export default component.exports